import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { useThemeMode } from "../../context/ThemeContext";

function getCssVar(name, fallback) {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return value || fallback;
}

export function LineChart({
  labels = [],
  values = [],
  xTitle = "",
  yTitle = "",
  height = 260,
  xAxisLabelRotate = 0,
  xAxisLabelInterval = "auto",
  yAxisMinInterval,
}) {
  const { mode } = useThemeMode();

  const option = useMemo(() => {
    const primary = getCssVar("--color-primary", "#2563eb");
    const borderColor = getCssVar("--color-border", "#e5e9f2");
    const textColor = getCssVar("--color-text-muted", "#64748b");

    return {
      darkMode: mode === "black",
      tooltip: { trigger: "axis" },
      grid: { top: 40, right: 16, bottom: xAxisLabelRotate ? 82 : 60, left: 60 },

      xAxis: {
        type: "category",
        data: labels,
        name: xTitle,
        nameLocation: "middle",
        nameGap: 35,
        nameTextStyle: { color: textColor, fontWeight: 600 },
        axisLabel: {
          color: textColor,
          rotate: xAxisLabelRotate,
          interval: xAxisLabelInterval,
        },
        axisLine: { lineStyle: { color: borderColor } },
      },

      yAxis: {
        type: "value",
        name: yTitle,
        nameLocation: "middle",
        nameGap: 50,
        nameRotate: 90,
        nameTextStyle: { color: textColor, fontWeight: 600 },
        axisLabel: { color: textColor },
        splitLine: {
          lineStyle: { color: borderColor, type: "dashed" },
        },
        minInterval: yAxisMinInterval,
      },

      series: [
        {
          data: values,
          type: "line",
          smooth: true,
          lineStyle: { color: primary, width: 3 },
          areaStyle: { color: primary, opacity: 0.1 },
          symbolSize: 8,
        },
      ],
    };
  }, [
    labels,
    values,
    mode,
    xTitle,
    yTitle,
    xAxisLabelRotate,
    xAxisLabelInterval,
    yAxisMinInterval,
  ]);

  return <ReactECharts option={option} style={{ height }} />;
}

export default LineChart;
